import React from "react";
import { Box, Typography, Grid, useMediaQuery } from "@mui/material";


import { FaInstagram,  FaLinkedin} from 'react-icons/fa';

const Footer = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        <Grid container spacing={4}>
          {/* Left Column (Company Name) */}
          <Grid item xs={12} md={4}>
            <Typography
              variant="h4"
              sx={{
                position: "absolute",
                top: isMobile ? "0px" : "50px", // Move to the absolute top
                left: "50px", // Move text to the absolute left
                fontSize: { xs: "5vw", sm: "28px", md: "32px" },
                whiteSpace: "nowrap",
                color: "white",
                padding: "0",
              }}
            >
              TECH INFORMATIC SOLUTIONS
            </Typography>
          </Grid>

          {/* Right Section - All Other Content */}
          <Grid item xs={12} md={8}>
            {/* 2nd Row: Right Section in Single Row for Mobile */}
            <Grid
              container
              spacing={4}
              direction={isMobile ? "row" : "row"} // Ensuring rows display in mobile view
              justifyContent={isMobile ? "space-between" : "flex-start"} // Space items evenly on mobile
              alignItems="flex-start"
            >
              <Grid item xs={4} sm={4}>
                <FooterColumn
                  heading="INDUSTRIES"
                  links={[
                    { text: "Healthcare", url: "/health" },
                    { text: "Education", url: "/education" },
                    { text: "Banking & Finance", url: "/banking" },
                    { text: "Automobile", url: "/automobile" },
                    { text: "Retail", url: "/retail" },
                    { text: "Manufacturing", url: "/manufacturing" },
                  ]}
                />
              </Grid>
              <Grid item xs={4} sm={4}>
                <FooterColumn
                  heading="SERVICES"
                  links={[
                    { text: "All Services", url: "/servicehome" },
                    { text: "Big Data Analytics", url: "/bigdata" },
                    { text: "IT Staffing", url: "/itstaffing" },
                    { text: "Operation Analytics", url: "/opeana" },
                    { text: "Websites & Web Apps", url: "/websites" },
                  ]}
                />
              </Grid>
              <Grid item xs={4} sm={4}>
                <FooterColumn
                  heading="COMPANY"
                  links={[
                    { text: "About Us", url: "/about" },
                    { text: "Contact", url: "/contact" },
                  ]}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>

      <Box sx={{ textAlign: "center", bgcolor: "black", color: "white", p: 1 }}>
        <Box
          sx={{
            my: 3,
            marginTop: "10px",
            "& svg": {
              fontSize: "26px",
              cursor: "pointer",
              mr: 2,
            },
            "& svg:hover": {
              color: "goldenrod",
              transform: "translateX(5px)",
              transition: "all 400ms",
            },
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "15px", // Space between icons
              marginTop: "20px", // Add spacing above icons
              marginBottom: "40px",
            }}
          >
           <a
          href="https://www.instagram.com/techinformaticsolutions_?igsh=MW56aWZ1aHp5cHZtdQ=="
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram"
        >
          <FaInstagram className="icon instagram" />
        </a>
        <a
          href="https://www.linkedin.com/company/techinformatic/" // Replace with your actual LinkedIn profile URL
          target="_blank"
          rel="noopener noreferrer"
          aria-label="LinkedIn"
        >
          <FaLinkedin className="icon linkedin" />
        </a>
            
          </div>
        </Box>
        <Typography variant="h5" sx={{ "@media (max-width:600px)": { fontSize: "1rem" } }}>
          <div style={styles.copyright}>
            Copyright © 2025 Tech Informatic solutions.
          </div>
        </Typography>
      </Box>
    </footer>
  );
};

// Footer Column Component
const FooterColumn = ({ heading, links }) => {
  return (
    <div style={styles.footerColumn}>
      <h3 style={styles.columnHeading}>{heading}</h3>
      <ul style={styles.linkList}>
        {links.map((link, index) => (
          <li key={index} style={styles.listItem}>
            <a
              href={link.url}
              style={styles.footerLink}
              onMouseEnter={(e) => (e.target.style.textDecoration = "underline")}
              onMouseLeave={(e) => (e.target.style.textDecoration = "none")}
            >
              {link.text}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

// Inline Styles
const styles = {
  footer: {
    backgroundColor: "#111",
    color: "white",
    width: "100%",
    position: "relative", // Ensures it sits properly
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    maxWidth: "1200px",
    margin: "0 auto",
    gap: "30px",
  },
  leftColumn: {
    flex: 1,
    minWidth: "250px",
    textAlign: "left",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start", // Ensures text aligns left
    padding: "0", // Remove any padding
    margin: "0", // Remove any margins
    width: "100%", // Ensures full-width for left alignment
  },
  rightSection: {
    flex: 3,
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)", // Default for Desktop → 3 Columns
    gap: "30px",
  },
  footerColumn: {
    marginBottom: "30px",
  },
  columnHeading: {
    fontSize: "16px",
    fontWeight: "bold",
    marginBottom: "10px",
    textTransform: "uppercase",
  },
  linkList: {
    listStyle: "none",
    padding: 0,
  },
  listItem: {
    marginBottom: "5px",
  },
  footerLink: {
    color: "#aaa",
    textDecoration: "none",
    fontSize: "14px",
    transition: "color 0.3s ease-in-out, text-decoration 0.3s ease-in-out",
    display: "inline-block",
  },
  copyright: {
    textAlign: "center",
    padding: "15px 0",
    backgroundColor: "#000",
    color: "white",
    fontSize: "14px",
    width: "100%",
    position: "absolute", // Moves it to the very bottom
    left: "0",
    bottom: "0", // Ensures it sticks to the bottom
  },
};

export default Footer;
